var _defs, _circle, _path, _path2, _circle2, _g, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBotonesSvg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2503.45 1222.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        filter: url(#drop-shadow-10);\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5 {\n        stroke-width: 0px;\n      }\n\n      .cls-1, .cls-3, .cls-5 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #d91111;\n      }\n\n      .cls-4 {\n        fill: #a81414;\n      }\n\n      .cls-5 {\n        filter: url(#drop-shadow-9);\n      }\n    "), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-9",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#26130a",
    floodOpacity: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-10",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 7,
    dy: 7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-2",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#26130a",
    floodOpacity: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-2",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 606.33,
    cy: 611.08,
    r: 525.8,
    transform: "translate(-254.51 607.72) rotate(-45)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m2196.05,341.64H728.6v545.98h1467.45c125.29,0,226.86-101.57,226.86-226.86v-92.26c0-125.29-101.57-226.86-226.86-226.86Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m2228.57,384.68H802.21v459.89h1426.37c80.26,0,145.55-103.15,145.55-229.94s-65.3-229.94-145.55-229.94Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 606.33,
    cy: 611.08,
    r: 387.04
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m1408.77,597.94c-5.43-5.89-8.15-14.2-8.15-24.93v-73.8c0-10.73,2.71-19.04,8.15-24.93,5.43-5.89,13.31-8.83,23.65-8.83s18.22,2.94,23.65,8.83c5.43,5.89,8.15,14.2,8.15,24.93v14.53h-20.41v-15.9c0-8.5-3.6-12.76-10.8-12.76s-10.8,4.25-10.8,12.76v76.75c0,8.38,3.6,12.56,10.8,12.56s10.8-4.19,10.8-12.56v-21h20.41v19.43c0,10.73-2.72,19.04-8.15,24.93-5.43,5.89-13.32,8.83-23.65,8.83s-18.22-2.94-23.65-8.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m1513.49,467.41h29.25l22.38,137.4h-21.59l-3.93-27.28v.39h-24.54l-3.93,26.89h-20.02l22.38-137.4Zm23.55,91.86l-9.62-67.92h-.39l-9.42,67.92h19.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m1595.14,467.41h32c11.12,0,19.24,2.59,24.34,7.75,5.1,5.17,7.66,13.12,7.66,23.85v8.44c0,14.26-4.71,23.29-14.13,27.09v.39c5.23,1.57,8.93,4.78,11.09,9.62,2.16,4.84,3.24,11.32,3.24,19.43v24.14c0,3.93.13,7.1.39,9.52.26,2.42.91,4.81,1.96,7.16h-21.98c-.79-2.22-1.31-4.32-1.57-6.28-.26-1.96-.39-5.5-.39-10.6v-25.12c0-6.28-1.02-10.66-3.04-13.15-2.03-2.48-5.53-3.73-10.5-3.73h-7.46v58.89h-21.59v-137.4Zm29.44,58.89c4.32,0,7.56-1.11,9.72-3.34,2.16-2.22,3.24-5.95,3.24-11.19v-10.6c0-4.97-.88-8.57-2.65-10.8-1.77-2.22-4.55-3.34-8.34-3.34h-9.81v39.26h7.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m1700.55,597.85c-5.5-5.95-8.24-14.49-8.24-25.62v-72.23c0-11.12,2.75-19.66,8.24-25.62,5.5-5.95,13.48-8.93,23.95-8.93s18.45,2.98,23.95,8.93c5.5,5.96,8.24,14.5,8.24,25.62v11.78h-20.41v-13.15c0-9.03-3.73-13.54-11.19-13.54s-11.19,4.51-11.19,13.54v75.18c0,8.9,3.73,13.35,11.19,13.35s11.19-4.45,11.19-13.35v-26.89h-10.8v-19.63h31.21v44.95c0,11.12-2.75,19.66-8.24,25.62-5.5,5.96-13.48,8.93-23.95,8.93s-18.45-2.98-23.95-8.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m1806.94,467.41h29.25l22.38,137.4h-21.59l-3.93-27.28v.39h-24.54l-3.93,26.89h-20.02l22.38-137.4Zm23.55,91.86l-9.62-67.92h-.39l-9.42,67.92h19.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m1365.1,639.16h30.82l13.74,98.34h.39l13.74-98.34h30.82v137.4h-20.41v-104.03h-.39l-15.7,104.03h-18.06l-15.7-104.03h-.39v104.03h-18.84v-137.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m1507.01,639.16h29.25l22.38,137.4h-21.59l-3.93-27.28v.39h-24.54l-3.93,26.89h-20.02l22.38-137.4Zm23.55,91.86l-9.62-67.92h-.39l-9.42,67.92h19.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m1592.4,769.6c-5.37-5.95-8.05-14.49-8.05-25.62v-7.85h20.41v9.42c0,8.9,3.73,13.35,11.19,13.35,3.66,0,6.44-1.08,8.34-3.24,1.9-2.16,2.85-5.66,2.85-10.5,0-5.76-1.31-10.83-3.93-15.21-2.62-4.38-7.46-9.65-14.53-15.8-8.9-7.85-15.11-14.95-18.65-21.3-3.53-6.35-5.3-13.51-5.3-21.49,0-10.86,2.75-19.27,8.24-25.22,5.5-5.95,13.48-8.93,23.95-8.93s18.16,2.98,23.46,8.93c5.3,5.96,7.95,14.5,7.95,25.62v5.69h-20.41v-7.07c0-4.71-.92-8.15-2.75-10.31-1.83-2.16-4.51-3.24-8.05-3.24-7.2,0-10.8,4.39-10.8,13.15,0,4.97,1.34,9.62,4.02,13.94,2.68,4.32,7.56,9.55,14.62,15.7,9.03,7.85,15.24,14.99,18.65,21.4,3.4,6.41,5.1,13.94,5.1,22.57,0,11.26-2.78,19.89-8.34,25.91-5.56,6.02-13.64,9.03-24.24,9.03s-18.39-2.98-23.75-8.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m1680.73,639.16h21.59v137.4h-21.59v-137.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m1732.35,639.16h21.79l14.13,106.58h.39l14.13-106.58h19.83l-20.81,137.4h-28.66l-20.81-137.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m1843.84,639.16h29.25l22.38,137.4h-21.59l-3.93-27.28v.39h-24.54l-3.93,26.89h-20.02l22.38-137.4Zm23.55,91.86l-9.62-67.92h-.39l-9.42,67.92h19.43Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m641.33,394.49h-143.3c-29.91,0-54.15,24.24-54.15,54.15v324.89c0,29.91,24.24,54.15,54.15,54.15h216.59c29.91,0,54.15-24.24,54.15-54.15v-251.6c0-7.18-2.85-14.07-7.93-19.14l-100.36-100.36c-5.08-5.08-11.96-7.93-19.14-7.93Zm5.6,94.76v-54.15l81.22,81.22h-54.15c-14.95,0-27.07-12.12-27.07-27.07Zm-85.17,172.03c-5.29,5.29-13.88,5.29-19.17,0-5.29-5.29-5.29-13.88,0-19.17l54.15-54.15c5.28-5.29,13.85-5.3,19.14-.02,0,0,.02.02.02.02l54.15,54.15c5.29,5.29,5.29,13.88,0,19.17s-13.88,5.29-19.17,0l-31.03-31.05v102.69c0,7.48-6.06,13.54-13.54,13.54s-13.54-6.06-13.54-13.54v-102.69l-31.03,31.05Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBotonesSvg1);
export default __webpack_public_path__ + "static/media/BOTONES_SVG 1.452709470ff28a782e88be39a0a415ba.svg";
export { ForwardRef as ReactComponent };